import * as Models from "../models";
import { QALineInfo, initPolyfills, QAEventInfo } from "sb-resp-lib";
import { QALiveSlipSelection } from "../models/QALiveSlipSelection/index";
import { QAEventInfoExt } from "../models";
initPolyfills();

export class Parser {
    /**
     *
     * @param initArray array with values to create QAEventInfo
     */
    public static QAEventInfoParser(initArray: any[]): QAEventInfoExt {
        let lines = new Array<QALineInfo>();
        if (Array.isArray(initArray[2])) {
            for (let value of initArray[2]) {
                let currLine = this.QaLineParse(value);
                lines.push(currLine);
            }
        }
        return new QAEventInfoExt({
            id: parseInt(initArray[0]),
            typeId: parseInt(initArray[1]),
            lines,
            name: initArray[3],
            typeName: initArray[5],
            branchId: parseInt(initArray[13]),
            leagueId: initArray[14],
            leagueName: initArray[15],
            date: new Date(initArray[16]),
            link: initArray[17],
        });

    }
    /**
     *
     * @param initData JS object
     * @param purchase  Open Bet Purchase
     */
    public static SPBetParser(initData: any): Models.SPOpenBet {
        return new Models.SPOpenBet(
            {
                betId: initData.BetID,
                generatedId: initData.GeneratedID,
                statusId: initData.StatusID,
                currentBalance: initData.Gain,
                deadHeatDeposit: initData.DeadHeatDeposit,
                commission: initData.Commission,
                profitLoss: initData.ProfitLoss,
                percentDeduction: initData.PercentDeduction,
                mapping: initData.Mappings,
                clientOdds: initData.OddsFrCl,
                numberOfBets: initData.NumOfBets,
                betSubType: initData.BSubType,
                betTypeId: initData.BType,
                comboSize: initData.ComboSize,
                betName: initData.BName,
                deposit: initData.Stake,
                gain: initData.Gain,
                odds: initData.Odds,
            }
        );
    }
    /**
     *
     * @param initData  SPSelection object data
     */
    public static SPSelectionParser(initData: any): Models.SPSelection {

        return new Models.SPSelection({
            selectionId: initData.SelectionID,
            statusId: initData.StatusID,
            odds: initData.Odds,
            points: initData.Points,
            result: initData.Result,
            id: initData.ID,
            lineId: initData.LineID,
            lineGroupId: initData.LineGroupID,
            rowTypeId: initData.RowTypeID,
            isOption: initData.IsOption,
            isRegular: initData.IsRegular,
            eventId: initData.EventID,
            orgOdds: initData.OrgOdds,
            clientOdds: initData.ClientOdds,
            branchId: initData.BranchID,
            leagueId: initData.LeagueID,
            masterLeagueId: initData.MasterLeagueID,
            splitTypeId: initData.SplitTypeID,
            eventTypeId: initData.EventTypeID,
            eventGroupId: initData.EventGroupID,
            isLive: initData.IsLive,
            qPar1: initData.QPar1,
            qPar2: initData.QPar2,
            orderId: initData.OrderID,
            branchName: initData.BranchName,
            leagueName: initData.LeagueName,
            eventName: initData.EventName,
            eventTypeName: initData.EventTypeName,
            eventDate: new Date(initData.EventDate),
        })
    }
    /**
     *
     * @param initData SPSelection data
     */
    public static SPPurchaseParser(initData: any): Models.SPPurchase {
        let jsonData = JSON.parse(initData.JSONProperties);
        return new Models.SPPurchase(
            {
                purchaseId: initData.PurchaseID,
                purchaseDate: new Date(initData.PurchaseDate),
                purchaseStatus: initData.PurchaseStatus,
                customerId: initData.CustomerID,
                currencyCode: initData.CurrencyCode,
                currentBalance: initData.CurrentBalance,
                oddsStyleId: initData.OddsStyleID,
                totalGain: initData.TotalGain,
                totalStake: initData.TotalStake,
                selections: initData.Selections.map(selection =>
                    Parser.SPSelectionParser.call(Parser,
                        {
                            ...jsonData.Selections.find(sel => sel.ID === selection.SelectionID),
                            ...selection
                        })
                ),
                bets: initData.Bets.map(bet =>
                    Parser.SPBetParser.call(Parser,
                        { ...bet, ...jsonData.Bets[0] }
                    ))
            });
    }

    /**
    *
    * @param initArray array with values to create QAEventInfo
    */
    public static QaLineParse(initArray: any[]): QALineInfo {

        return new QALineInfo({
            id: parseInt(initArray[0]),
            odds: parseInt(initArray[1]),
            lineName: initArray[2],
            lineTypeId: parseInt(initArray[3]),
            fractOddsDividend: parseInt(initArray[5]),
            fractOddsDivisor: parseInt(initArray[6]),
            lineStateId: parseInt(initArray[7]),
            lineTypeName: initArray[8],
            qaParameter2: parseInt(initArray[9]),
            qaParameter1: parseInt(initArray[10]),
            feedSelectionId: parseInt(initArray[13])
        });
    }
    public static QALiveSlipSelectionParser(event: { masterEventId: number } & QAEventInfo, jsonData: any) {
        let slipSelection = new QALiveSlipSelection({
            masterEventId: event.masterEventId,
            lineId: jsonData.LineID,
            eventId: event.id,
            type: event.typeId,
            leagueId: jsonData.LeagueID,
            branchId: jsonData.BranchID,
            branchName: jsonData.BranchName,
            leagueName: jsonData.LeagueName,
            eventTypeId: event.typeId,
            eventTypeName: jsonData.EventTypeName,
            oppositeEventTypeId: jsonData.OppositeEventTypeID,
            team1Name: jsonData.Team1Name,
            team2Name: jsonData.Team2Name,
            liveGroupId: jsonData.LiveGroupID,
            preLiveGroupId: jsonData.PreliveGroupID,
            maxBet: jsonData.maxBet,
            minBet: jsonData.minBet,
            waitingAllowed: jsonData.waitingAllowed,
            singleSelectionRisk: jsonData.SingleSelectionRisk,
            lineTypeName: jsonData.LineTypeName,
            odds: jsonData.Odds,
            eventDate: event.date,
            lineTypeId: jsonData.LineTypeID,
            betTypeId: 7,
            useEventName: jsonData.useEventName,
            eventName: jsonData.EventName,
            lineName: jsonData.LineName,
            asianLineName: jsonData.AsianLineName,
            mappedLineTypeId: jsonData.MappedLineTypeID,
            swapped: jsonData.Swapped,
            splitTypeId: jsonData.SplitTypeID,
            SISEventId: jsonData.SISEventID,
            GBSEventId: jsonData.GBSEventID,
            feedEventId: jsonData.FeedEventID,
            feedProviderId: jsonData.FeedProviderID,
            isEachWayEnabled: jsonData.isEachWayEnabled,
            relatedToId: jsonData.RelatedToID,
            danger: jsonData.Danger,
            qaParameter1: jsonData.QAParameter1,
            qaParameter2: jsonData.QAParameter2
        });
        if (jsonData.ScoreChanged) {
            slipSelection.score1 = jsonData.ScoreChanged[0];
            slipSelection.score2 = jsonData.ScoreChanged[1];
        }
        return slipSelection;
    }

    public static masterEventIncidentParser(initArray: any[]): Models.MasterEventIncident {
        return new Models.MasterEventIncident({
            incidentID: parseInt(initArray[0]),
            masterEventID: parseInt(initArray[1]),
            incitentTimeMs: parseInt(initArray[2]),
            incidentTypeID: parseInt(initArray[3]),
            incidentStatusID: parseInt(initArray[4]),
        });
    }

}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./data/parsers/Parser.ts